module.exports = __webpack_public_path__ + "/login_ui/img/bg-e54d872c4a69815cdac29c7996d6e60c.svg";